// extracted by mini-css-extract-plugin
export default {"backGround":"styles_backGround__iCqns"};